import {useParams} from '@github-ui/react-router'
import {ReposIssuesSidebar as SharedRepoIssuesSidebar} from '@github-ui/repos-issues-sidebar/ReposIssuesSidebar'

import {usePreloadSidebarPages} from '../../hooks/use-preload-sidebar-pages'

export function RepoIssuesSidebar({collapsible}: {collapsible?: boolean} = {}) {
  usePreloadSidebarPages()
  const {owner, repo} = useParams<{owner: string; repo: string}>()
  return <SharedRepoIssuesSidebar owner={owner ?? ''} repo={repo ?? ''} collapsible={collapsible} />
}
